module.exports = __webpack_public_path__ + "img/jiaoshoulv.49820f95.png";